import {
  //  convertToDemographicsCodes,
  AttributeLookup,
  BundleAttributesLookup,
  BundleLookup,
  DemographicLookup,
  ScoreLookup,
  AvailableAscendQuestLookups,
  DeprecatedAscendQuestLookups,
  InputLabelsMap,
  //  areAttributesSame,
  DeprecatedAttribute,
  getEmptyAvailableAscendQuestLookups,
  getEmptyDeprecatedAscendQuestLookups,
  AttributesFromFullAttribute,
  FullAttributeLookup,
  AddonProductLookup,
  //  doesSubcodeHaveAccess,
} from '@ssar-app/domain';
// import { ProgramWizardModel } from './models';

// const shouldDisableOrExclude = (
//   input: {
//     isDisabled: boolean;
//     exclusiveSubCodes?: string[];
//     code: string;
//   },
//   subCode: string,
// ): boolean => {
//   return (
//     input.isDisabled || !doesSubcodeHaveAccess(subCode, input.exclusiveSubCodes)
//   );
// };

// TODO: (CV) Should we also consider the changes that might happen to the output layout fields too?
export class ProgramWizardLookupsManager {
  private lookups: AvailableAscendQuestLookups =
    getEmptyAvailableAscendQuestLookups();
  private deprecatedLookups: DeprecatedAscendQuestLookups =
    getEmptyDeprecatedAscendQuestLookups();

  constructor(
    lookups: AvailableAscendQuestLookups,
    deprecatedLookups: DeprecatedAscendQuestLookups,
  ) {
    this.lookups = lookups;
    this.deprecatedLookups = deprecatedLookups;
  }

  public getScoresLookups(): ScoreLookup[] {
    return this.lookups.scoresLookups;
  }

  public getAddonProductsLookups(): AddonProductLookup[] {
    return this.lookups.addonProductsLookups;
  }

  public getDemographicsLookups(): DemographicLookup[] {
    return this.lookups.demographicsLookups;
  }

  public getDemographicsLookupsCodes(): string[] {
    return this.lookups.demographicsLookups.map((a) => a.code);
  }

  public getDemographicsLookupsName(code: string): string {
    const demoLookup = this.lookups.demographicsLookups.find(
      (a) => a.code === code,
    );
    return demoLookup?.name || demoLookup?.code || '';
  }

  public getBundlesLookups(): BundleLookup[] {
    return this.lookups.bundlesLookups;
  }

  public getFullAttributesLookups(): FullAttributeLookup[] {
    return this.lookups.fullAttributesLookups;
  }

  public getAttributesLookups(): AttributeLookup[] {
    return this.lookups.attributesLookups;
  }

  public getBundleAttributes(): BundleAttributesLookup[] {
    return this.lookups.bundleAttributes;
  }

  public getAttributesFromFullAttribute(): AttributesFromFullAttribute[] {
    return this.lookups.attributesFromFullAttribute;
  }

  public getInputLabelsMap(): InputLabelsMap {
    return this.lookups.inputLabelsMap;
  }

  public doesDisabledScoresLookupsExist(): boolean {
    return this.deprecatedLookups.scoresLookups.length > 0;
  }

  public getDisableScoresLookupsNames(): string[] {
    return this.deprecatedLookups.scoresLookups.map((a) => a?.name || a.code);
  }

  public getDisableScoresLookupsCodes(): string[] {
    return this.deprecatedLookups.scoresLookups.map((a) => a.code);
  }

  public doesDisabledTrendviewsLookupsExist(): boolean {
    return this.deprecatedLookups.trendviewLookups.length > 0;
  }

  public getDisableTrendviewsLookupsNames(): string[] {
    return this.deprecatedLookups.trendviewLookups.map(
      (a) => a?.name || a.code,
    );
  }

  public doesDisabledAddonProductsLookupsExist(): boolean {
    return this.deprecatedLookups.addonProductsLookups.length > 0;
  }

  public getDisableAddonProductsLookupsNames(): string[] {
    return this.deprecatedLookups.addonProductsLookups.map(
      (a) => a?.name || a.code,
    );
  }

  public getDisableAddonProductsLookupsCodes(): string[] {
    return this.deprecatedLookups.addonProductsLookups.map((a) => a.code);
  }

  public doesDisabledDemographicsLookupsExist(): boolean {
    return this.deprecatedLookups.demographicsLookups.length > 0;
  }

  public getDisableDemographicsLookupsNames(): string[] {
    return this.deprecatedLookups.demographicsLookups.map(
      (a) => a.name || a.code,
    );
  }

  public doesDisabledBundlesLookupsExist(): boolean {
    return this.deprecatedLookups.bundlesLookups.length > 0;
  }

  public getDisableBundlesLookupsNames(): string[] {
    return this.deprecatedLookups.bundlesLookups.map((a) => a?.name || a.code);
  }

  public getDisableBundlesLookupsCodes(): string[] {
    return this.deprecatedLookups.bundlesLookups.map((a) => a.code);
  }

  public doesDisabledAttributesLookupsExist(): boolean {
    return this.deprecatedLookups.attributesLookups.length > 0;
  }

  public getDisableAttributesLookupsNames(): string[] {
    return this.deprecatedLookups.attributesLookups.map(
      (a) => a?.name || a.code,
    );
  }

  public getDisableAttributesLookups(): DeprecatedAttribute[] {
    return this.deprecatedLookups.attributesLookups;
  }

  public doesLookupsExist(): boolean {
    return (
      this.lookups.scoresLookups.length > 0 ||
      this.lookups.addonProductsLookups.length > 0 ||
      this.lookups.demographicsLookups.length > 0 ||
      this.lookups.bundlesLookups.length > 0 ||
      this.lookups.attributesLookups.length > 0
    );
  }

  public doesDisabledLookupsExist(): boolean {
    return (
      this.deprecatedLookups.scoresLookups.length > 0 ||
      this.deprecatedLookups.bundlesLookups.length > 0 ||
      this.deprecatedLookups.attributesLookups.length > 0 ||
      this.deprecatedLookups.trendviewLookups.length > 0 ||
      this.deprecatedLookups.addonProductsLookups.length > 0 ||
      this.deprecatedLookups.demographicsLookups.length > 0
    );
  }

  public static empty(): ProgramWizardLookupsManager {
    return new ProgramWizardLookupsManager(
      getEmptyAvailableAscendQuestLookups(),
      getEmptyDeprecatedAscendQuestLookups(),
    );
  }

  // public static build(
  //   initialLookups: AvailableAscendQuestLookups,
  //   model: ProgramWizardModel,
  // ): Promise<ProgramWizardLookupsManager> {
  //   return new Promise((resolve, reject) => {
  //     const deprecatedLookups: DeprecatedAscendQuestLookups = {
  //       attributesLookups: [],
  //       bundlesLookups: [],
  //       scoresLookups: [],
  //       trendviewLookups: [],
  //       demographicsLookups: [],
  //     };
  //     const { subCode } = model;
  //     try {
  //       const {
  //         scoresLookups: initialScoresLookups,
  //         trendviewLookups: initialTrendviewLookups,
  //         demographicsLookups: initialDemographicsLookups,
  //         bundlesLookups: initialBundlesLookups,
  //         attributesLookups: initialAttributesLookups,
  //       } = initialLookups;
  //       const availableScoresLookups = initialScoresLookups?.filter((a) => {
  //         const isDisabledOrExcluded = shouldDisableOrExclude(a, subCode);
  //         if (
  //           isDisabledOrExcluded &&
  //           model.scoresAndTrendviewStepData?.scores?.includes(a.code)
  //         ) {
  //           deprecatedLookups.scoresLookups.push(a);
  //         }
  //         return !isDisabledOrExcluded;
  //       });

  //       // TODO: (CV) Needs to be revisited
  //       /*
  //         Reasoning from TR:
  //           That's because let's say score A has exclusive subcode 111 and another A has 222
  //           now if I selected 222 subcode, A (from 111) will be sent to disabledScoreLookups and A (from 222) will be sent to scoresLookups
  //           this additional filter will remove A from disabledScoreLookups since it shouldn't be disabled for 222
  //         CV: But the assumption agreement is we will not have duplicate codes, instead the exlcusiveSubCodes will be applied to manage the access to scores/bundles/attributes etc.
  //         TR: There are attributes having same group, category and code with diff exclusive subcodes, so this additional filter is still nedded
  //        */
  //       deprecatedLookups.scoresLookups =
  //         deprecatedLookups.scoresLookups.filter(
  //           (a) => !availableScoresLookups.find((b) => b.code === a.code),
  //         );

  //       const availableTrendviewLookups = initialTrendviewLookups?.filter(
  //         (a) => {
  //           const isDisabledOrExcluded = shouldDisableOrExclude(a, subCode);
  //           if (
  //             isDisabledOrExcluded &&
  //             model.scoresAndTrendviewStepData?.trendviewFields?.includes(
  //               a.code,
  //             )
  //           ) {
  //             deprecatedLookups.trendviewLookups.push(a);
  //           }
  //           return !isDisabledOrExcluded;
  //         },
  //       );

  //       deprecatedLookups.trendviewLookups =
  //         deprecatedLookups.trendviewLookups.filter(
  //           (a) => !availableTrendviewLookups.find((b) => b.code === a.code),
  //         );

  //       const availableBundlesLookups = initialBundlesLookups?.filter((a) => {
  //         const isDisabledOrExcluded = shouldDisableOrExclude(a, subCode);
  //         if (
  //           isDisabledOrExcluded &&
  //           model.attributesAndBundlesStepData?.bundles?.includes(a.code)
  //         ) {
  //           deprecatedLookups.bundlesLookups.push(a);
  //         }
  //         return !isDisabledOrExcluded;
  //       });

  //       deprecatedLookups.bundlesLookups =
  //         deprecatedLookups.bundlesLookups.filter(
  //           (a) => !availableBundlesLookups.find((b) => b.code === a.code),
  //         );

  //       const convertedDemos = convertToDemographicsCodes(
  //         model.demographicsStepData,
  //       );
  //       const availableDemographicsLookups = initialDemographicsLookups?.filter(
  //         (a) => {
  //           const isDisabledOrExcluded = shouldDisableOrExclude(a, subCode);
  //           if (isDisabledOrExcluded && convertedDemos.includes(a.code)) {
  //             deprecatedLookups.demographicsLookups.push(a);
  //           }
  //           return !isDisabledOrExcluded;
  //         },
  //       );
  //       deprecatedLookups.demographicsLookups =
  //         deprecatedLookups.demographicsLookups.filter(
  //           (a) => !availableDemographicsLookups.find((b) => b.code === a.code),
  //         );

  //       const availableAttributesLookups = initialAttributesLookups?.filter(
  //         (a) => {
  //           const isDisabledOrExcluded = shouldDisableOrExclude(a, subCode);
  //           if (
  //             isDisabledOrExcluded &&
  //             (model.attributesAndBundlesStepData?.attributes || []).findIndex(
  //               (b) => areAttributesSame(a, b),
  //             ) !== -1
  //           ) {
  //             const disabledAttribute: DeprecatedAttribute = {
  //               name: a.name,
  //               code: a.code,
  //               category: a.category,
  //               group: a.group,
  //               exclusiveSubCodes: a.exclusiveSubCodes,
  //             };
  //             deprecatedLookups.attributesLookups.push(disabledAttribute);
  //           }
  //           return !isDisabledOrExcluded;
  //         },
  //       );
  //       deprecatedLookups.attributesLookups =
  //         deprecatedLookups.attributesLookups.filter(
  //           (a) =>
  //             availableAttributesLookups.findIndex((b) =>
  //               areAttributesSame(a, b),
  //             ) === -1,
  //         );

  //       const lookups = {
  //         ...initialLookups,
  //         scoresLookups: availableScoresLookups,
  //         trendviewLookups: availableTrendviewLookups,
  //         demographicsLookups: availableDemographicsLookups,
  //         bundlesLookups: availableBundlesLookups,
  //         attributesLookups: availableAttributesLookups,
  //       };
  //       const instance = new ProgramWizardLookupsManager(
  //         lookups,
  //         deprecatedLookups,
  //       );
  //       resolve(instance);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }
}
